import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { OrganisationStatusPage } from "~/pages/Settings/Organisations/organisation/status/OrganisationStatusPage";

export const Route = createFileRoute(
  "/_app/settings/organisations/$organisationId/status",
)({
  head: () => ({ meta: [{ title: i18n.t("general:documentTitle.status") }] }),
  component: OrganisationStatusPage,
});
